import type { ReactNode } from 'react';
import type { TabelaPrecoProduto } from '@/features/tabela-preco/types/TabelaPrecoProduto';
import { Container } from '@/components/Container';
import { tabelaPrecoTipoToStr } from '@/features/tabela-preco/types/enum';
import { numberToCurrency, numberToPercent } from '@/std/format';

function InfoRow({ label, children }: { label: ReactNode; children: ReactNode }) {
    return (
        <tr className='border border-gray-300'>
            <td className='border border-gray-300 px-4 py-2'>{label}</td>
            <td className='border border-gray-300 px-4 py-2 font-bold'>{children}</td>
        </tr>
    );
}

export function ProdutoTabTabelaPrecoDrawerInfo({
    tabelaPreco,
}: {
    tabelaPreco: TabelaPrecoProduto;
}) {
    return (
        <Container>
            <table className='w-full border-collapse border border-gray-300'>
                <tbody>
                    <InfoRow label='Produto'>{tabelaPreco.produto.pro_descricao}</InfoRow>

                    {tabelaPreco.produto_pacote_barra && (
                        <InfoRow label='Pacote de barras'>
                            {tabelaPreco.produto_pacote_barra.pcb_descricao}
                        </InfoRow>
                    )}

                    <InfoRow label='Tabela de preço'>{tabelaPreco.tap_descricao}</InfoRow>

                    <InfoRow label='Tipo'>
                        {`${tabelaPrecoTipoToStr(tabelaPreco.tap_tipo_variacao)} ${numberToPercent(tabelaPreco.tap_percentual)}`}
                    </InfoRow>

                    <InfoRow label='Preço do produto'>
                        {numberToCurrency(tabelaPreco.produto.pro_preco_venda)}
                    </InfoRow>

                    <InfoRow label='Preço mínimo'>
                        {numberToCurrency(tabelaPreco.produto.pro_preco_minimo)}
                    </InfoRow>

                    <InfoRow label='Preço calculado'>
                        {numberToCurrency(tabelaPreco.preco_calculado)}
                    </InfoRow>
                </tbody>
            </table>
        </Container>
    );
}
